module.exports = __webpack_public_path__ + "static/img/8bg_8.04e3391.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_8.png
// module id = 768
// module chunks = 1